// This file is generated by a script and should not be modified directly.
const markdown: string =
  'This element includes:\n\n- the partner responsible for the job offer\n- the unique identifier of the job offer within the "La bonne alternance" information system\n'
export default markdown
